import { Outlet, useParams } from 'react-router-dom';

import { useMedico } from './hooks/useMedico';

import { BackChevron, Error, Loader } from '../../../../../components';

import styles from './MedicoHeader.module.css';

export const MedicoHeader = () => {

  let { id } = useParams();

  const { medicoQuery: { isLoading, isError, data: medico } } = useMedico(id);
  
  return (
    <>
      {(isLoading)
          ? <Loader />
          : <>
          {(isError)
              ? <Error />
              : <>
                <div className="row">
                  <div className="col">
                    <div className={styles.panel + " " + styles.panelNoHeader}>
                      <div className={styles.medicosHeaderContainer}>
                        <div className="d-flex align-items-center">
                          <BackChevron />
                          <div className={styles.medicosHeaderUserDataContainer}>
                            {(medico.img != null) &&
                            <div>
                                <div className={styles.medicosHeaderUserImg} style={{backgroundImage: 'url(\'' + ((medico.img != null) ? medico.img : 'https://placehold.co/200x200?text=Img') + '\')'}}></div>
                            </div>
                            }
                            <div>
                                <div className={styles.medicosHeaderCorreo}>Correo: { medico.email }</div>
                                <div className="d-flex">
                                  <div>
                                    <div className={styles.medicosHeaderNombre}>{ medico.displayName }</div>
                                    <div className="d-flex justify-content-between">
                                      <div className={styles.medicosHeaderEdad}>{ medico.edad }</div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.medicoHeaderTabsContainer}></div>
                      </div>
                      <Outlet />
                    </div>
                  </div>
                </div>
              </>
          }
          </>
      }
    </>
  )
}